/*
 * Ring size starts UNCHOSEN (proposal 2026-10-28, kardima-business/audits/2026-10-28-pdp-popup-proposal.md).
 *
 * Why it is done this way: Dawn re-renders the variant picker from the server on every option change and
 * needs one checked value per option to find the variant. So the size radio stays checked underneath
 * (whatever the URL or the first variant says, e.g. 48), and this script only:
 *   1. draws the size row as "not chosen" (class kardima-size-picker--unchosen) and says "Velg størrelse",
 *   2. stops "Legg i handlekurv" until the buyer has tapped a size, then scrolls to the size row,
 *   3. remembers the tapped size per product for this browser tab (sessionStorage), so coming back from
 *      the cart does not ask again.
 * Metal and carat come from the URL's ?variant= as before, so every old link still opens the same ring
 * (see keepSizeFromLink for when the link's size is kept).
 * No variant, price or link changes. With JS off the page works exactly as before.
 */
(function () {
  'use strict';

  var BUTTON_TEXT = 'Velg størrelse';
  var STATE_TEXT = 'Velg størrelse';

  function infoRoot() {
    return document.querySelector('product-info[id^="MainProduct"]') || document.querySelector('product-info');
  }
  function sizeFieldset() {
    var root = infoRoot();
    return root ? root.querySelector('[data-kardima-size]') : null;
  }
  function handle() {
    var vs = document.querySelector('variant-selects[data-product-handle]');
    return vs ? vs.getAttribute('data-product-handle') : location.pathname;
  }
  function key() {
    return 'kardimaSize:' + handle();
  }
  function stored() {
    try { return window.sessionStorage.getItem(key()); } catch (e) { return null; }
  }
  function store(value) {
    try { window.sessionStorage.setItem(key(), value); } catch (e) { /* private mode: asks again next load */ }
  }
  function checkedValue(fs) {
    var input = fs && fs.querySelector('input:checked');
    return input ? input.value : null;
  }
  function submitButton() {
    var root = infoRoot();
    return root ? root.querySelector('[id^="ProductSubmitButton"]') : null;
  }

  var chosen = false;

  function decideInitial() {
    var fs = sizeFieldset();
    if (!fs) return;
    var s = stored();
    chosen = !!s && s === checkedValue(fs);
    if (!chosen && keepSizeFromLink()) chosen = true;
  }

  /* Link rule (proposal 2026-10-28, "link safety"):
     - plain product URL: size not chosen;
     - ?variant= from a Meta ad or post (fbclid, utm_source facebook/instagram/meta/ig): metal and carat
       from the variant, size not chosen (the ads all point at size 48 variants);
     - ?variant= from anywhere else (Google Shopping and its crawler, emails, saved links): the size in the
       link stays chosen, as Google Merchant Center asks for ("pre-select the correct product variant"). */
  function keepSizeFromLink() {
    var q = new URLSearchParams(window.location.search);
    if (!q.get('variant')) return false;
    if (q.get('fbclid')) return false;
    var src = (q.get('utm_source') || '').toLowerCase();
    if (/^(facebook|fb|instagram|ig|meta)/.test(src)) return false;
    return true;
  }

  function paint() {
    var fs = sizeFieldset();
    if (!fs) return;
    fs.classList.toggle('kardima-size-picker--unchosen', !chosen);
    var state = fs.querySelector('[data-kardima-size-state]');
    var want = chosen ? checkedValue(fs) || '' : STATE_TEXT;
    if (state && state.textContent !== want) state.textContent = want;
    var inputs = fs.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i += 1) {
      if (!chosen) inputs[i].setAttribute('aria-checked', 'false');
      else inputs[i].removeAttribute('aria-checked');
    }
    if (chosen) hideError();

    var btn = submitButton();
    if (btn && !btn.disabled) {
      var span = btn.querySelector('span');
      if (span) {
        if (!chosen && span.textContent.trim() !== BUTTON_TEXT) {
          if (!btn.dataset.kardimaAddText) btn.dataset.kardimaAddText = span.textContent.trim();
          span.textContent = BUTTON_TEXT;
        } else if (chosen && span.textContent.trim() === BUTTON_TEXT) {
          span.textContent = btn.dataset.kardimaAddText || (window.variantStrings && window.variantStrings.addToCart) || 'Legg i handlekurv';
        }
      }
    }
  }

  function showError() {
    var fs = sizeFieldset();
    if (!fs) return;
    var err = fs.querySelector('[data-kardima-size-error]');
    if (err) err.hidden = false;
    fs.classList.add('kardima-size-picker--error');
    fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var first = fs.querySelector('input[type="radio"]');
    if (first) {
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
  }
  function hideError() {
    var fs = sizeFieldset();
    if (!fs) return;
    var err = fs.querySelector('[data-kardima-size-error]');
    if (err) err.hidden = true;
    fs.classList.remove('kardima-size-picker--error');
  }

  /* A tap on any size counts as a choice, also on the one that is already checked underneath
     (that one fires no "change" event). */
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!(t instanceof Element)) return;
    var fs = t.closest('[data-kardima-size]');
    if (!fs) return;
    var input = null;
    var label = t.closest('label');
    if (label && label.htmlFor) input = document.getElementById(label.htmlFor);
    if (!input && t.matches('input[type="radio"]')) input = t;
    if (!input) return;
    chosen = true;
    store(input.value);
    paint();
  }, true);

  /* Block the add to cart while no size is chosen. Capture phase on document runs before Dawn's
     product-form submit handler. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
    if (!sizeFieldset() || chosen) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showError();
  }, true);

  /* Dawn swaps the picker and resets the button text after every option change: paint again. */
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame ? window.setTimeout(run, 0) : run();
    function run() { scheduled = false; paint(); }
  }

  function init() {
    decideInitial();
    paint();
    var root = infoRoot();
    if (root) new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
